import type { ObjectMerge } from 'type-fest'

export const MockModel =
  <Model extends object>(
    defaults: <Overrides extends Partial<Model>>(overrides: Overrides) => Model
  ) =>
  <Overrides extends Partial<Model>>(overrides: Overrides) =>
    ({ ...defaults(overrides), ...overrides }) as ObjectMerge<Model, Overrides>
